import React from 'react';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { Button as ReactButton } from 'react-bootstrap';
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup';

import styles from './BottomBar.module.css';

//using styles not class because react-bootstrap overrides classes but not styles
const arrowButtonStyle = {
    color: '#ffffff',
    backgroundColor: '#188ded',
    fontSize: '15px',
    padding: '8px 12px',
    outline: 'none'
};

const discardButtonStyle = {
    width: '120px',
    color: '#333333',
    backgroundColor: '#ffffff',
    fontSize: '15px',
    padding: '8px 16px'
};

const saveButtonStyle = {
    width: '120px',
    color: '#ffffff',
    backgroundColor: '#188ded',
    marginLeft: '30px',
    fontSize: '15px',
    padding: '8px 16px'
};

const BottomBar = ({
    discardAll,
    discardAllDisabled,
    saveAllDisabled,
    actions,
    actionsError,
    saveError,
    saveSuccess,
    saveAll,
    discardTab,
    discardTabDisabled,
    saveTab,
    saveTabDisabled,
    showPerTabButtons
}) => {
    const dropdownActions = [];
    for (const actionIndex in actions) {
        const action = actions[actionIndex];
        dropdownActions.push(
            <MenuItem
                key={`menuAction_${actionIndex}`}
                onClick={action.disabled ? () => {} : action.clicked}
                disabled={action.disabled}>
                {action.name}
            </MenuItem>
        );
        if (actionIndex < actions.length - 1) {
            dropdownActions.push(<MenuItem key={`menuDivider_${actionIndex}`} divider />);
        }
    }

    return (
        <div className={styles.bottomBar}>
            <div className={styles.leftSide}>
                {actions && (
                    <DropdownButton
                        className={styles.dropdownButton}
                        noCaret={false}
                        disabled={false}
                        title={'Actions'}
                        dropup={true}
                        id={'action-dropdown1'}>
                        {[...dropdownActions]}
                    </DropdownButton>
                )}
                {actionsError && <span className={styles.actionsError}>{actionsError}</span>}
            </div>
            <div className={styles.rightSide}>
                {saveError && <div className={styles.errorMsg}>{saveError}</div>}
                {saveSuccess && <div className={styles.successMsg}>{saveSuccess}</div>}
                {showPerTabButtons ? (
                    <>
                        <ButtonGroup variant="contained" color="primary" aria-label="split button">
                            <ReactButton style={discardButtonStyle} disabled={discardAllDisabled} onClick={discardAll}>
                                Discard All
                            </ReactButton>
                            <DropdownButton
                                id={'discardAllDropdown'}
                                pullRight
                                dropup
                                disabled={discardTabDisabled}
                                style={{ ...arrowButtonStyle, backgroundColor: '#ffffff', color: '#333333' }}
                                title={''}>
                                <MenuItem disabled={discardTabDisabled} onClick={discardTab}>
                                    Discard Tab
                                </MenuItem>
                            </DropdownButton>
                        </ButtonGroup>
                        <ButtonGroup variant="contained" color="#fff" aria-label="split button">
                            <ReactButton style={saveButtonStyle} disabled={saveAllDisabled} onClick={saveAll}>
                                Save All
                            </ReactButton>
                            <DropdownButton
                                id={'saveAllDropdown'}
                                pullRight
                                dropup
                                disabled={saveTabDisabled}
                                style={arrowButtonStyle}
                                title={''}>
                                <MenuItem disabled={saveTabDisabled} onClick={saveTab}>
                                    Save Tab
                                </MenuItem>
                            </DropdownButton>
                        </ButtonGroup>
                    </>
                ) : (
                    <>
                        <ReactButton style={discardButtonStyle} disabled={discardAllDisabled} onClick={discardAll}>
                            Discard All
                        </ReactButton>
                        <ReactButton style={saveButtonStyle} disabled={saveAllDisabled} onClick={saveAll}>
                            Save All
                        </ReactButton>
                    </>
                )}
            </div>
        </div>
    );
};

export default React.memo(BottomBar);
